/* tempexp_15344-full-file */
import darkCoverImage from 'img/aside-promo-modal/cloud-dark.jpg';
import lightCoverImage from 'img/aside-promo-modal/cloud-light.jpg';
import { toolbarActions } from 'reactApp/appHelpers/toolbarActions';
import { ROOT_FOLDER_ID } from 'reactApp/constants/magicIdentificators';
import { getFeatureRequiredSignUpWhenDownloading } from 'reactApp/modules/features/features.selectors';
import { TemplateVariantString } from 'reactApp/modules/features/features.types';
import { getCurrentPublicItem, isOwnPublic } from 'reactApp/modules/public/public.selectors';
import { SettingsSelectors } from 'reactApp/modules/settings/settings.selectors';
import { RootState, store as reduxStore } from 'reactApp/store';
import { openAsidePromoModal } from 'reactApp/ui/AsidePromoModal/AsidePromoModal.helpers';
import { EAsidePromoModalTheme } from 'reactApp/ui/AsidePromoModal/AsidePromoModal.types';
import { sendGa as _sendGa } from 'reactApp/utils/ga';
import { EQueryParams } from 'server/helpers/getRequestParams';

import { SUCCESS_AUTH_WHEN_DOWNLOAD } from './constants';
import { reDownloadController } from './reDownloadController';

type AsideModalGaAction = 'shw-aside-mdl' | 'cls-aside-mdl' | 'clck-aside-mdl';
type ReDownloadSnackGaAction = 'shw-redwnld-snack' | 'cls-redwnld-snack' | 'clck-redwnld-snack';
type ReDownloadTooltipGaAction = 'shw-redwnld-tltip' | 'cls-redwnld-tltip' | 'clck-redwnld-tltip';

const sendGa = (
    action: AsideModalGaAction | ReDownloadSnackGaAction | ReDownloadTooltipGaAction,
    variant?: TemplateVariantString,
    placement?: 'single' | 'folder'
): void => _sendGa('rqird-auth-whn-dwnld', action, variant, { placement });

const getSuccessPage = () => {
    const url = new URL(window.location.href);
    url.searchParams.append(EQueryParams.action, SUCCESS_AUTH_WHEN_DOWNLOAD);

    return url.toString();
};

const isSuccessAuthWhenDownload = (state: RootState) => {
    const queryParams = SettingsSelectors.getQueryParams(state);
    const queryAction = queryParams.action;

    const isPublicOwner = isOwnPublic(state);

    return (
        queryAction === SUCCESS_AUTH_WHEN_DOWNLOAD && !isPublicOwner /* Отсекаем от флоу юзеров, которые авторизовались в свой же паблик */
    );
};

const goToCloudLink = `${ROOT_FOLDER_ID}?${EQueryParams.action}=${SUCCESS_AUTH_WHEN_DOWNLOAD}`;

const showAsideModal = () => {
    const state = reduxStore.getState();
    const requiredSignUpVariant = getFeatureRequiredSignUpWhenDownloading(state);

    const item = getCurrentPublicItem(state);

    const theme = !item?.isFolder ? EAsidePromoModalTheme.dark : undefined;
    const imageUrl = !item?.isFolder ? darkCoverImage : lightCoverImage;

    if (requiredSignUpVariant === 'variant1') {
        openAsidePromoModal({
            title: 'Храните в Облаке',
            text: 'Файл не будет занимать место на устройстве, а бесплатных гигабайтов хватит на сотни фото и видео',
            buttonText: 'Сохранить в Облако',
            imageUrl,
            theme,
            onClick: () => {
                if (item) {
                    toolbarActions.clone({
                        id: item.id,
                        destination: '',
                        source: 'toolbar',
                        fromReDownload: true,
                    });
                }

                reDownloadController.resetParams();

                sendGa('clck-aside-mdl', 'variant1');
            },
            onShow: () => sendGa('shw-aside-mdl', 'variant1'),
            onClose: () => sendGa('cls-aside-mdl', 'variant1'),
        });
    }

    if (requiredSignUpVariant === 'variant2') {
        openAsidePromoModal({
            title: 'Файл скачивается',
            text: 'Этот файл можно сохранить к себе в Облако — так удобнее поделиться им с друзьями',
            buttonText: 'Перейти в Облако',
            imageUrl,
            theme,
            onClick: () => {
                location.href = goToCloudLink;

                reDownloadController.resetParams();

                sendGa('clck-aside-mdl', 'variant2');
            },
            onShow: () => sendGa('shw-aside-mdl', 'variant2'),
            onClose: () => sendGa('cls-aside-mdl', 'variant2'),
        });
    }
};

const isSuccessAuthVariant = (variant: TemplateVariantString) => (state: RootState) => {
    const requiredSignUpVariant = getFeatureRequiredSignUpWhenDownloading(state);

    return isSuccessAuthWhenDownload(state) && requiredSignUpVariant === variant;
};

export const requiredAuthorizationHelpers = {
    getSuccessPage,
    isSuccessAuthWhenDownload,
    goToCloudLink,
    showAsideModal,
    isSuccessAuthVariant1: isSuccessAuthVariant('variant1'),
    isSuccessAuthVariant2: isSuccessAuthVariant('variant2'),
    sendGa,
};
